"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isRequired = exports.requiringOptions = void 0;
exports.attrFormatter = attrFormatter;
const index_js_1 = require("../../../errors/index.js");
const formatValuePath_js_1 = require("../../../schema/actions/utils/formatValuePath.js");
const any_js_1 = require("./any.js");
const anyOf_js_1 = require("./anyOf.js");
const list_js_1 = require("./list.js");
const map_js_1 = require("./map.js");
const primitive_js_1 = require("./primitive.js");
const record_js_1 = require("./record.js");
const set_js_1 = require("./set.js");
exports.requiringOptions = new Set(['always', 'atLeastOnce']);
const isRequired = (attribute) => exports.requiringOptions.has(attribute.required);
exports.isRequired = isRequired;
function* attrFormatter(attribute, rawValue, options = {}) {
    const { format = true, transform = true, valuePath } = options;
    if (rawValue === undefined) {
        if ((0, exports.isRequired)(attribute) && options.partial !== true) {
            const path = (0, formatValuePath_js_1.formatValuePath)(valuePath);
            throw new index_js_1.DynamoDBToolboxError('formatter.missingAttribute', {
                message: `Missing required attribute for formatting${path !== undefined ? `: '${path}'` : ''}.`,
                path,
                payload: {}
            });
        }
        if (transform) {
            if (format) {
                yield undefined;
            }
            else {
                return undefined;
            }
        }
        return undefined;
    }
    switch (attribute.type) {
        case 'any':
            return yield* (0, any_js_1.anyAttrFormatter)(attribute, rawValue, options);
        case 'null':
        case 'boolean':
        case 'number':
        case 'string':
        case 'binary':
            return yield* (0, primitive_js_1.primitiveAttrFormatter)(attribute, rawValue, {
                ...options,
                attributes: undefined
            });
        case 'set':
            return yield* (0, set_js_1.setAttrFormatter)(attribute, rawValue, options);
        case 'list':
            return yield* (0, list_js_1.listAttrFormatter)(attribute, rawValue, options);
        case 'map':
            return yield* (0, map_js_1.mapAttrFormatter)(attribute, rawValue, options);
        case 'record':
            return yield* (0, record_js_1.recordAttrFormatter)(attribute, rawValue, options);
        case 'anyOf':
            return yield* (0, anyOf_js_1.anyOfAttrFormatter)(attribute, rawValue, options);
    }
}
